// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"90bedf8b","145":"ddd0e5d9","150":"46024a8b","293":"52826c34","370":"1cd2b243","468":"08f9ec9a","558":"cdc8afac","699":"b1d01033","748":"d029ff7e","869":"f55e8b85","964":"658201b7","965":"77baffff"}[chunkId] + ".chunk.js";
};